import React, { useEffect, useState } from 'react';
import { CardHeader } from '@mui/material';
import { StyledCellLink, Percentage, Weight } from '../Common/DataGrid/CellComponents';
import { getDateRangeFilterOperator, getRangeFilterOperator } from '../Common/DataGrid/FilterComponents';
import { select_commonCellProps, text_commonCellProps } from '../Common/DataGrid/utils';
import {
    DataGrid,
    PageTitleWithToolTip
} from '../Common';
import Routes from '../../routes';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { fetchFilterValues } from '../../utils';

const dateRangeFilterOperator = getDateRangeFilterOperator({});
const rangeFilterOperator = getRangeFilterOperator({});

const columns = [
    {
        field: 'region',
        headerName: 'Region',
        ...text_commonCellProps
    },
    {
        field: 'locationName',
        headerName: 'Location',
        ...select_commonCellProps,
        renderCell: ({ row: { locationName, locationId } }) => (
            <StyledCellLink
                path={`/Location/${locationId}`}
                text={locationName}
                from={"Compliance Center"}
                primaryLink={true}
            />
        )
    },
    {
        field: 'assetName',
        headerName: 'Asset Name',
        ...text_commonCellProps,
        renderCell: ({ row: { assetName, assetId } }) => (
            <StyledCellLink
                path={`/Inventory/${assetId}`}
                text={assetName}
                from={"Compliance Center"}
                primaryLink={true}
            />
        )
    },
    {
        field: 'serviceDateString',
        headerName: 'Service Date',
        filterOperators: dateRangeFilterOperator,
    },
    {
        field: 'serviceEventId',
        headerName: 'Service Event ID',
        ...text_commonCellProps,
    },
    {
        field: 'assetType',
        headerName: 'Type',
        ...select_commonCellProps
    },
    {
        field: 'materialTypeName',
        headerName: 'Material Type',
        ...select_commonCellProps
    },
    {
        field: 'gasCapacityString',
        headerName: 'Gas Capacity',
        valueGetter: (value) => value,
        filterOperators: rangeFilterOperator
    }
]

const EPA30Day = () => {

    const [filters, setFilters] = useState([]);

    const fetchFilters = async () => {
        const filters = await fetchFilterValues(Routes.Dashboard.EPA30DayDropdown());
        setFilters(filters);
    };

    useEffect(() => { fetchFilters() }, []);

    return (
        <DataGrid
            url={Routes.Dashboard.EPA30Day(false)}
            exportButtonURL={Routes.Dashboard.EPA30Day(true)}
            filterOptions={filters}
            columns={columns}
            rowCount="5"
            tableId={'epa-30-day-leak-repair-deadline-table'}
            exportFileName={"EPA 30 DAY LEAK REPAIR DEADLINE"}
            exportButtonAlt={"Export EPA 30 DAY LEAK REPAIR DEADLINE (.csv)"}
            noResultText="Oops...It is empty here..."
            noResultText2="Create a new asset or change your search criteria."
            dataGridSx={{
                border: 'none'
            }}
        />
    );
}

export default EPA30Day;
